module.exports = __webpack_public_path__ + "static/pbcaricature-298e6bcf15e3895a1a439be8a2f9e5e3.png";